import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { CookieConsentShellComponent } from './consent/cookie-consent-shell.component';
import { ConsentService } from './consent/consent.service';
import { NativeShellService } from './core/native-shell/native-shell.service';
import { SplashService } from './core/native-shell/splash.service';
import { IapAuthBridgeService } from './services/iap-auth-bridge.service';
import { NativeOAuthService } from './services/native-oauth.service';
import { PwaService } from './core/pwa/pwa.service';
import { TelemetryAuthBridgeService } from './telemetry/telemetry-auth-bridge.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, CookieConsentShellComponent],
})
export class AppComponent {
  constructor(
    private readonly pwaService: PwaService,
    private readonly nativeShellService: NativeShellService,
    private readonly splashService: SplashService,
    /** Eager init: hydrate consent + device id before first interaction. */
    _consent: ConsentService,
    /** Side effect: keeps Clarity Identify in sync when Clarity is allowed. */
    _telemetryAuthBridge: TelemetryAuthBridgeService,
    /** Side effect: RevenueCat login/logout on native. */
    _iapAuthBridge: IapAuthBridgeService,
    /** Side effect: OAuth deep-link return on native. */
    _nativeOAuth: NativeOAuthService,
  ) {
    this.pwaService.initialize();
    this.nativeShellService.initialize();
    this.splashService.initialize();
    _nativeOAuth.initialize();
  }
}
